import { Component, EventEmitter, Input, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TenantDataService } from 'app/config/services/tenant-data.service';
import { CommunityUserToUserCommand } from 'app/library/community-user/models/community-user-to-user.command';
import { FeatureService } from 'app/library/feature/services/feature.service';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { MaxBrainUtils } from 'app/projects/core/src/lib/utils';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';
import { User } from 'app/projects/user/src/lib/models/user';

@Component({
    selector: 'app-community-user-details',
    templateUrl: './user-details.component.html',
    styleUrls: ['./user-details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class CommunityUserDetailsComponent extends UnsubscribeOnDestroy {
    @Input()
    myProfile: User;

    @Input()
    user: User;

    onStartConversationEvent = new EventEmitter<CommunityUserToUserCommand>();
    profilePictureSrc = `${MaxBrainUtils.baseUrl}/assets/images/avatars/profile.jpg`;
    isChatFeatureActive: boolean;

    constructor(
        public dialogRef: MatDialogRef<CommunityUserDetailsComponent>,
        public tenantDataService: TenantDataService,
        private _featureService: FeatureService,
        private _router: Router
    ) {
        super();
        this.isChatFeatureActive = this._featureService.checkFeatureStatus('chat');
    }

    onStartConversation() {
        const comunityUserAvatar = this.tenantDataService.edManUrl + '/bundles/maxbrain/images/' + this.user.avatar;
        const communityUser = new CommunityUserToUserCommand(this.user, comunityUserAvatar);
        this.onStartConversationEvent.next(communityUser);
    }

    goToUpdateMyProfile() {
        this._router.navigate(['/profile/tab/profile-details']);
        this.dialogRef.close();
    }
}
